import React from 'react'
import { NotificationEntity } from '../../../../@types';


interface props {
    notification: NotificationEntity
} 


const SuccessNotification = ({ notification }: props) => (
    <div className="flex flex-row bg-white rounded-md">
      <div className={notification.isRead ? 'bg-blue-900 w-2' : 'bg-green-600 w-2'}></div>
      <div className="w-439 h-116 bg-blue-100 p-4 flex flex-col gap-5 ">
        <div className="flex justify-between">
          <p className="font-semibold text-md">{notification.type}</p>
          <p className="font-light text-sm">{notification.entityType}</p>
        </div>
        <div>
          <p>
            <span className="font-semibold">{notification.id}</span> has been generated and sent to the customer:
            <span className="font-semibold">{notification.customerId}</span>
          </p>
        </div>
      </div>
    </div>
  );


  export default SuccessNotification